import {createApi} from '@reduxjs/toolkit/query/react';
import {btBaseQuery, storeToken} from '../../Common/common';
import {updateState} from '../services/authSlice';

export const api = createApi({
  reducerPath: 'api',
  baseQuery: async (args, api, extraOptions) => {
    const result = await btBaseQuery(args, api, extraOptions);
    
    // Check for new token in response headers and update if present
    // RTK Query's fetchBaseQuery returns response in result.meta.response
    const response = result.meta?.response as Response | undefined;
    if (response) {
      const newToken = response.headers.get('token');
      if (newToken) {
        // Update Redux state with new token
        api.dispatch(updateState({token: newToken}));
        // Store token in AsyncStorage
        await storeToken(newToken);
      }
    }
    
    return result;
  },
  tagTypes: ['Collection'],
  endpoints: () => ({}),
});

